import {
  ADD_ADMIN,
  DELETE_ADMIN,
  GET_ADMINS,
  SET_ADMINS,
  SET_LOADING,
  UPDATE_ADMIN,
} from '../actions/admin';

export default (
  state = {
    admins: null,
    loading: null,
  },
  { type, data }
) => {
  switch (type) {
    case GET_ADMINS:
      return { ...state };

    case SET_ADMINS:
      return { ...state, admins: data };
    case UPDATE_ADMIN:
      return {
        ...state,
        admins: state.admins.map((admin) =>
          admin.id === data.id ? data : admin
        ),
      };
    case ADD_ADMIN:
      return { ...state, admins: [...state.admins, data] };
    case DELETE_ADMIN:
      return {
        ...state,
        admins: state.admins.filter((admin) => admin.id !== data),
      };

    case SET_LOADING:
      return { ...state, loading: data };

    default:
      return state;
  }
};
